import {localizeI18nObj} from "../../../utils/i18n";

const SHARED_OBJECT_TYPE = "type";
const SHARED_OBJECT_TITLE = "title";

export const getSharedObjectColumns = (t, language, languages) => [
  {
    field: SHARED_OBJECT_TYPE,
    title: t("scenes.usersSettings.modals.deleteUser.sharedObjects.columns.type"),
    render: ({type}) => getFormattedType(t, type),
    renderText: ({type}) => getFormattedType(t, type),
    renderTooltip: ({type}) => getFormattedType(t, type)
  },
  {
    field: SHARED_OBJECT_TITLE,
    title: t("scenes.usersSettings.modals.deleteUser.sharedObjects.columns.title"),
    render: ({title}) => localizeI18nObj(title, language, languages),
    renderText: ({title}) => localizeI18nObj(title, language, languages),
    renderTooltip: ({title}) => localizeI18nObj(title, language, languages)
  }
];

const getFormattedType = (t, type) => {
  const types = {
    View: t("commons.user.objects.view"),
    ViewWidget: t("commons.user.objects.viewWidget"),
    DashboardWidget: t("commons.user.objects.dashboardWidget"),
    Dashboard: t("commons.user.objects.dashboard")
  };
  return types[type];
};
